//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import VueMq from "vue-mq";
import axios from "axios";

import NsTopnavImageOverlay from "../NsTopnavImageOverlay.vue";
import NsTopnavNavigation from "./NsTopnavNavigation.vue";
import NsDynamicHtml from "../NsDynamicHtml.vue";

import { fromJsonString } from "@nuskin/ns-common-lib";

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

export default {
  name: "NsTopnavSection",
  components: {
    NsTopnavImageOverlay,
    NsTopnavNavigation,
    NsDynamicHtml
  },
  props: {
    /**
     * Used to fetch custom components from parsys in AEM
     */
    customComponentsUrl: {
      type: String,
      default: ""
    },
    /**
     * Image
     */
    image: {
      type: [String, Object],
      default: function() {
        return {
          src: "",
          alt: "Top Nav Image",
          overlayText: ""
        };
      }
    },
    /**
     * stringified JSON data for the navigation
     */
    navigation: {
      type: String,
      default: ""
    },
    /**
     * Type of component used for the custom component
     * Possible values: "nstopnavproducthighl", "nstopnavproductline",
     * "nstopnavlinklist", "default"
     */
    navType: {
      type: String,
      default: "default"
    },
    /**
     * Boolean for if section is open
     */
    opened: Boolean,
    /**
     * Boolean to hide the see all link in the navigation
     */
    hideSeeAll: Boolean
  },
  data: function() {
    return {
      /**
       * Data obj that contains markup from ajax call from customComponentsUrl
       * Warning: Could contain stale markup due to race condition;
       * Always check !!customComponentsUrl in template.
       */
      customComponentMarkup: "",
      /**
       * Navigation object
       */
      navigationObject: []
    };
  },
  computed: {
    navImage() {
      return fromJsonString(this.image);
    },
    localNavigation() {
      if (this.navigation) {
        let numberOfSubnavs;
        if (this.navType === "legacy") {
          numberOfSubnavs = 6;
        } else if (this.navType === "storefront") {
          // include all links
          numberOfSubnavs = undefined;
        } else if (this.navType === "nsTopnavProductHighlight") {
          numberOfSubnavs = 2;
        } else if (
          ["nsTopnavProductLine", "nsTopnavGivingBack"].includes(this.navType)
        ) {
          numberOfSubnavs = 0;
        } else {
          numberOfSubnavs = 3;
        }
        return JSON.parse(this.navigation).slice(0, numberOfSubnavs);
      } else {
        return [];
      }
    },
    showNavigation() {
      return !["nsTopnavProductLine", "nsTopnavGivingBack"].includes(
        this.navType
      );
    },
    showImageOverlay() {
      return (
        this.navImage &&
        this.navImage.src &&
        ![
          "nsTopnavProductLine",
          "nsTopnavProductHighlight",
          "nsTopnavGivingBack"
        ].includes(this.navType)
      );
    }
  },
  watch: {
    // when section is opened, add a title attribute to ellipsied links
    opened(open) {
      if (open) {
        setTimeout(function() {
          const links = document.querySelectorAll(".secondary-nav a");
          for (const link of links) {
            if (
              link.offsetWidth > 0 &&
              !link.hasAttribute("title") &&
              link.offsetWidth < link.scrollWidth
            ) {
              link.setAttribute("title", link.innerText);
            }
          }
        }, 1000);
      }
    },
    customComponentsUrl: {
      immediate: true,
      handler() {
        this.getCustomComponents();
      }
    }
  },
  methods: {
    /**
     * Used to fetch custom components from provided customComponentsUrl
     */
    async getCustomComponents() {
      if (this.customComponentsUrl) {
        const response = await axios.request({
          method: "get",
          url: this.customComponentsUrl
        });

        this.customComponentMarkup = response.data.trim();
      } else {
        this.customComponentMarkup = "";
      }
    }
  }
};
